import UnassignedSpecs from "./UnassignedSpecsContainer";
export default UnassignedSpecs;
